/**
 * @fileoverview COD Checker Script - Optimized to minimize redundant AJAX calls.
 * @version 1.3
 * @description Data is stored until the next 1PM (24hrs cycle). If localStorage has valid data,
 *              API calls to /api/pincode_lookup_status/ and /api/pincode_lookup/ are skipped.
 *              Also validates zipcode to ensure it's exactly 6 digits and does not start with 0.
 */
 
(function (factory) {
  let attempts = 0;
  const start = () => {
    if (window.jQuery) {
      factory(window.jQuery);
      return;
    }

    attempts += 1;
    if (attempts <= 80) {
      window.setTimeout(start, 50);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})(function ($) {
  'use strict';

  if (window.SylviCodCheckerInitialized) return;
  window.SylviCodCheckerInitialized = true;

  // Variables for DOM elements (assigned on document ready)
  let $document, $zipCodeRoot, $shippinDetail, $zipcodeInput, $checkZipCodeBtn, $zipLoader, $customCartForm;
  let isRequestInProgress = false;

  // Global configuration and in-memory cache
  const domainName = 'https://fims.skmienterprise.com';
  const isCustomzipFunctionality = true; // Use boolean for clarity
  const isAddToCartButtonDisable = true;
  const aK = 'YXBpLWFwaS5zeWx2aS5pbi1rZXk=';
  const aS = 'YXBpLVlYQnBMV0Z3YVM1emVXeDJhUzVwYmkxclpYaz0tc2VjcmV0';
  const aH = 'api.sylvi.in';
  const responseCache = {};

  // Utility: Returns the next expiry time (in ms) set to 1PM.
  const getNextExpiryTime = () => {
    const now = new Date();
    const expiry = new Date(now);
    if (now.getHours() < 13) {
      expiry.setHours(13, 0, 0, 0);
    } else {
      expiry.setDate(expiry.getDate() + 1);
      expiry.setHours(13, 0, 0, 0);
    }
    return expiry.getTime();
  };

  // Stub for public holiday check (extend as needed)
  const isPublicHoliday = (date) => {
    // List holidays in YYYY-MM-DD format
    const publicHolidays = ["2025-02-28"];
    
    // Format the provided date as YYYY-MM-DD
    const formattedDate = date.toISOString().split('T')[0];
    
    return publicHolidays.includes(formattedDate);
  };


  /**
   * Updates localStorage with API response data and stores the cutoff time.
   */
  const updateLocalStorage = (data, zipcode) => {
    localStorage.setItem('fp_zipcode', data.message);
    localStorage.setItem('fp_only_zipcode', zipcode);
    localStorage.setItem('fp_city', data.zipdata.city);
    localStorage.setItem('fp_state', data.zipdata.state);
    localStorage.setItem('fp_edd', data.zipdata.edd);
    localStorage.setItem('fp_default_html', data.zipdata.html_default);
    localStorage.setItem('fp_edd_source', data.zipdata.edd_source);
    localStorage.setItem('fp_shown_edd', data.zipdata.shown_edd);
    localStorage.setItem('fp_expiry', getNextExpiryTime());
    // Store the cutoff time (in ms) for the countdown timer.
    localStorage.setItem('fp_cut_off_time', new Date(data.zipdata.cut_off_time).getTime());
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));

  const formatDeliveryDate = (value) => {
    if (!value) return '';
    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toLocaleDateString('en-IN', { month: 'short', day: 'numeric' });
    }
    return String(value).replace(/,\s*\d{4}$/, '');
  };

  const renderDeliverySummary = () => {
    const zipcode = localStorage.getItem('fp_only_zipcode');
    const city = localStorage.getItem('fp_city');
    const edd = formatDeliveryDate(localStorage.getItem('fp_shown_edd') || localStorage.getItem('fp_edd'));
    const place = [city, 'India'].filter(Boolean).join(', ');

    return `
      <div class="sylvi-delivery-summary">
        ${place ? `<div class="sylvi-delivery-place">To <strong>${escapeHtml(place)}</strong></div>` : ''}
        <div class="sylvi-delivery-promises">
          <span>COD</span>
          ${edd ? `<span>By <strong>${escapeHtml(edd)}</strong></span>` : ''}
        </div>
        <div class="sylvi-delivery-cutoff">Order in <span id="counter"></span>${zipcode ? ' for this estimate' : ''}</div>
      </div>
    `;
  };

  /**
   * Makes an AJAX POST request with timeout and caches the response.
   */
  const ajaxPost = async (url, data = {}) => {
    const cacheKey = url + JSON.stringify(data);
    if (responseCache[cacheKey]) {
      return responseCache[cacheKey];
    }
    try {
      const response = await $.ajax({
        method: 'POST',
        headers: {
          'x-api-key': aK,
          'x-api-secret': aS,
          'referrer': aH
        },
        url,
        data,
        dataType: 'json',
        timeout: 10000 // 10-second timeout
      });
      responseCache[cacheKey] = response;
      return response;
    } catch (error) {
      console.error('AJAX Error:', error.responseText || error);
      return null;
    }
  };

  /**
   * Checks if stored data is valid based on expiry.
   */
  const isStoredDataValid = () => {
    const storedExpiry = localStorage.getItem('fp_expiry');
    if (!storedExpiry) return false;
    if (isPublicHoliday(new Date())) return false;
    return Date.now() < parseInt(storedExpiry, 10);
  };

  /**
   * Fetches the application status.
   * (This may update expiry; it's called on every page load.)
   */
  const getAppStatus = async () => {
    if (isStoredDataValid()) {
      activateApp(true);
      return;
    }
    const response = await ajaxPost(`${domainName}/api/pincode_lookup_status/`);
    if (response && response.status) {
      localStorage.setItem('fp_expiry', getNextExpiryTime());
      activateApp(true);
    }
  };

  /**
   * Processes a successful API response.
   */
  const handleSuccessfulResponse = (response, zipcode) => {
    updateLocalStorage(response, zipcode);
    $shippinDetail.html(renderDeliverySummary());
    $zipCodeRoot.addClass('is-checked');
    $zipCodeRoot.find('.shippin_details_error').remove();
    // Start countdown timer using the cutoff time from the response.
    countDown(new Date(response.zipdata.cut_off_time).getTime());
    changeImpulseProductButtonStatus(true);
    toggleImpulsePayButton(true);
    enableChangeButton();
    updateCustomCartURL(true);
  };

  /**
   * Processes an error API response.
   */
  const handleErrorResponse = (response) => {
    $zipCodeRoot.find('.shippin_details_error').remove();
    $shippinDetail.empty();
    const errorMessage = response.type === 'array'
      ? response.message.zipcode
      : response.message;
    $zipCodeRoot.find(".input-group1").after(
      `<span class="shippin_details_error" style="padding: 0; display: block; color:#FF0066;">${errorMessage}</span>`
    );
    changeImpulseProductButtonStatus(false);
    toggleImpulsePayButton(false);
    updateCustomCartURL(false);
  };

  /**
   * Activates the application UI.
   * If valid data exists, displays the stored info and starts the countdown timer.
   */
  const activateApp = (status = false) => {
    if (status) {
      if (localStorage.getItem('fp_zipcode') && localStorage.getItem('fp_only_zipcode')) {
        $shippinDetail.html(renderDeliverySummary());
        $zipCodeRoot.addClass('is-checked');
        $zipcodeInput.val(localStorage.getItem('fp_only_zipcode'));
        enableChangeButton();
        toggleImpulsePayButton(true);
        // Retrieve stored cutoff time and start countdown if it's still in the future.
        const storedCutOff = localStorage.getItem('fp_cut_off_time');
        if (storedCutOff && Date.now() < parseInt(storedCutOff, 10)) {
          countDown(parseInt(storedCutOff, 10));
        }
      } else {
        enableCheckButton();
        checkZipcodeAvailability(
          isAddToCartButtonDisable,
          false,
          "Enter Pincode to check service availability in your area. <a href='#zipcode' class='call-zipcode-box'>Check Now</a>"
        );
        toggleImpulsePayButton(false);
      }
    }
  };

  /**
   * Enables the Check button.
   */
  const enableCheckButton = () => {
    $zipCodeRoot.removeClass('is-checked is-checking');
    $checkZipCodeBtn
      .text('CHECK')
      .removeClass('custom-change-zipcode')
      .addClass('custom-check-zipcode')
      .prop('disabled', false);
  };

  /**
   * Enables the Change button.
   */
  const enableChangeButton = () => {
    $zipCodeRoot.addClass('is-checked').removeClass('is-checking');
    $checkZipCodeBtn
      .text('CHANGE')
      .removeClass('custom-check-zipcode')
      .addClass('custom-change-zipcode')
      .prop('disabled', false);
  };

  /**
   * Toggles the status of the impulse product buttons.
   */
  const changeImpulseProductButtonStatus = (btnStatus) => {
    const toggleStatus = (selector, status) => {
      const $element = $(selector);
      $element.prop("disabled", !status);
      if ($element.hasClass('cbb-frequently-bought-add-button')) {
        $element.css({ opacity: status ? "1" : "0.4", cursor: status ? "pointer" : "default" });
      }
    };

    [
      '.payment-buttons [name="add"]',
      '.payment-buttons .shopify-payment-button .shopify-payment-button__button',
      '.payment-buttons .shopify-payment-button .custom-payment-btn',
      '.cbb-frequently-bought-recommendations-container .cbb-frequently-bought-add-button.add-to-cart'
    ].forEach(selector => toggleStatus(selector, btnStatus));
  };

  /**
   * Toggles the custom impulse payment button.
   */
  const toggleImpulsePayButton = (btnStatus) => {
    // $('.payment-buttons [data-shopify="payment-button"]').css({ display: btnStatus ? "none" : "block" });
    // $('.payment-buttons .custom-shopify-payment-button').css({ display: btnStatus ? "block" : "none" });
  };

  /**
   * Checks the availability of a zipcode.
   */
  const checkZipcodeAvailability = (disableCart, btnStatus, statusMessage) => {
    if (disableCart) {
      if ($(".availability-msg").length > 0) {
        $('.availability-msg')
          .html(statusMessage)
          .css({ padding: btnStatus ? "0" : "0 0 10px", display: btnStatus ? "none" : "block" });
      }
      $(".product-form__cart-submit, #fpZipCode .add-to-cart").prop("disabled", !btnStatus);
      return true;
    }
    return false;
  };

  /**
   * Updates the custom cart URL based on status.
   */
  const updateCustomCartURL = (status) => {
    if (!$customCartForm || $customCartForm.length === 0) return;
    let currentAction = $customCartForm.attr('action') || "";
    currentAction = currentAction ? currentAction.split('?')[0] : "";
    const cartUrl = status
      ? `?checkout[shipping_address][country]=India&checkout[shipping_address][province]=${localStorage.getItem('fp_state')}&checkout[shipping_address][city]=${localStorage.getItem('fp_city')}&checkout[shipping_address][zip]=${localStorage.getItem('fp_only_zipcode')}`
      : '';
    $customCartForm.attr('action', currentAction + cartUrl);
  };

  /**
   * Starts a countdown timer.
   */
  const countDown = (countDownDate) => {
    const counterEl = document.getElementById("counter");
    if (!counterEl) return;
    const interval = setInterval(() => {
      const now = Date.now();
      const distance = countDownDate - now;
      if (distance < 0) {
        clearInterval(interval);
        window.location.reload();
        counterEl.innerHTML = "";
        return;
      }
      const hours = (`0${Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))}`).slice(-2);
      const minutes = (`0${Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))}`).slice(-2);
      const seconds = (`0${Math.floor((distance % (1000 * 60)) / 1000)}`).slice(-2);
      counterEl.innerHTML = `<strong>${hours}h ${minutes}m ${seconds}s</strong>`;
    }, 1000);
  };

  /**
   * Debounce utility.
   */
  const debounce = (func, wait) => {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  };

  /**
   * Initializes the page.
   * If stored data is expired but a zipcode exists, refresh the data by calling validateZipcode.
   */
  const initializePage = async () => {
    const storedZip = localStorage.getItem('fp_only_zipcode');
    if (storedZip && !isStoredDataValid()) {
      // Stored data has expired â€“ refresh using the stored pincode.
      await validateZipcode(storedZip);
      activateApp(true);
      return;
    }
    if (isStoredDataValid()) {
      activateApp(true);
      return;
    }
    activateApp(true);
  };

  /**
   * Calls the API with the provided zipcode to refresh the data.
   */
  const validateZipcode = async (zipcode) => {
    const url = `${domainName}/api/pincode_lookup/?accountId=57162236113`;
    const response = await ajaxPost(url, { zipcode });
    if (response && response.status) {
      updateLocalStorage(response, zipcode);
    }
  };

  // Initialize DOM-dependent variables and event handlers on document ready
  $(document).ready(function () {
    $document = $(document);
    $zipCodeRoot = $('#fpZipCode');
    if (!$zipCodeRoot.length) return;
    $shippinDetail = $zipCodeRoot.find('#shippinDetail');
    $zipcodeInput = $zipCodeRoot.find('#zipcode');
    $checkZipCodeBtn = $zipCodeRoot.find('#checkZipCode');
    $zipLoader = $zipCodeRoot.find('.zip-loader');
    $customCartForm = $(".custom-cart-form-class");

    getAppStatus();
    initializePage();

    // Event: Click on Check Zip Code button
    $document.on('click', '.custom-check-zipcode', async function (event) {
      event.preventDefault();
      if (isRequestInProgress) return;
      isRequestInProgress = true;

      try {
        const zipcode = String($zipcodeInput.val() || "").trim();
        console.log("Zipcode entered:", zipcode);

        // Validate: exactly 6 digits and not starting with 0.
        const zipRegex = /^[1-9]\d{5}$/;
        if (!zipRegex.test(zipcode)) {
          console.log("Invalid zipcode:", zipcode);
          $zipCodeRoot.find(".shippin_details_error").remove();
          $zipCodeRoot.find(".input-group1").after(
            `<span class="shippin_details_error" style="padding: 0; display: block; color:#FF0066;">
               Please enter a valid 6-digit zip code not starting with 0.
             </span>`
          );
          return;
        }

        $zipCodeRoot.addClass('is-checking');
        $zipLoader.hide();
        $checkZipCodeBtn.text('CHECKING').prop('disabled', true);

        const requestUrl = isCustomzipFunctionality
          ? `${domainName}/api/pincode_lookup/?accountId=57162236113`
          : `${domainName}/api/checkShippingEstimationByZipCode/`;

        const response = await ajaxPost(requestUrl, { zipcode });

        if (response) {
          if (response.status) {
            handleSuccessfulResponse(response, zipcode);
          } else {
            handleErrorResponse(response);
            enableCheckButton();
          }
        } else {
          enableCheckButton();
        }
      } finally {
        $zipLoader.hide();
        $zipCodeRoot.removeClass('is-checking');
        $checkZipCodeBtn.prop('disabled', false);
        isRequestInProgress = false;
      }
    });

    // Event: Click on Change Zip Code button
    $document.on('click', '.custom-change-zipcode', function () {
      $shippinDetail.empty();
      $zipcodeInput.focus().val('');
      $zipLoader.hide();
      enableCheckButton();
      updateCustomCartURL(false);
      toggleImpulsePayButton(false);
    });

    // Event: Debounced keyup on zipcode input (handles backspace and Enter)
    $zipcodeInput.on('keyup', debounce(function (event) {
      if (event.keyCode === 8) {
        $shippinDetail.empty();
        enableCheckButton();
        $zipCodeRoot.find('.shippin_details_error').remove();
      }
      if (event.keyCode === 13) {
        event.preventDefault();
        $checkZipCodeBtn.filter('.custom-check-zipcode').trigger('click');
      }
    }, 300));

    // Event: Focus on zipcode input when #pinAnchor is clicked
    $document.on('click', '#pinAnchor', function () {
      $zipcodeInput.focus();
    });
  });
  
});
